import React from 'react';
import { RentalManagerEnvironmentContext } from '../components/RentalManagerEnvironmentProvider';

export const useSsrRedirect = () => {
  const { environment } = React.useContext(RentalManagerEnvironmentContext);
  const setSsrRedirect = React.useMemo(() => {
    return (url: string) => {
      environment.nodeEnv.ssrRedirect = url;
    };
  }, [environment.nodeEnv]);

  return setSsrRedirect;
};
